/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Avatar, Box, Menu, MenuItem } from '@mui/material';
import { useModal } from 'context/ModalContext';
import { Modal } from '@mui/material';
import MentionViewProfile from './modals/MentionViewProfile';
import ImageViewerModal from './modals/ImageViewerModal';

const UserAvatarComponent = ({ userData, style, showMenu = true }) => {
    const [openViewProfileModal, setOpenViewProfileModal] = useState(false);
    const sx = style ? style : { borderRadius: '50%', height: '3rem', width: '3rem' };
    const { isOpen, content, openModal, closeModal } = useModal();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <Box>
            <Avatar
                src={userData?.profile_image || null}
                className="img-fit"
                alt={userData?.first_name || userData?.user_name || 'user'}
                style={sx}
                onClick={userData?.user_id ? handleClick : undefined}
            />

            {showMenu && userData?.user_id && (
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button'
                    }}
                >
                    <MenuItem
                        onClick={() => {
                            openModal(
                                <ImageViewerModal
                                    open={true}
                                    onClose={() => closeModal()}
                                    images={userData?.profile_image ? [userData?.profile_image] : []}
                                />
                            );
                            handleClose();
                        }}
                    >
                        View Photo
                    </MenuItem>
                    {userData?.user_id && (
                        <MenuItem
                            onClick={() => {
                                if (userData?.user_id) {
                                    setOpenViewProfileModal(true);
                                    handleClose();
                                }
                            }}
                        >
                            View Profile
                        </MenuItem>
                    )}
                </Menu>
            )}

            {showMenu && userData?.user_id && (
                <Modal
                    keepMounted
                    open={openViewProfileModal && !!userData?.user_id}
                    onClose={() => setOpenViewProfileModal(false)}
                    aria-labelledby="keep-mounted-modal-title"
                    aria-describedby="keep-mounted-modal-description"
                >
                    <MentionViewProfile userId={userData.user_id} setOpenMentionProfile={setOpenViewProfileModal} />
                </Modal>
            )}
        </Box>
    );
};

export default UserAvatarComponent;
